export default {
    LOGO: "http://simple.techchina.org.cn/assets/logo/sjz/logo.png?_=" + new Date().getTime(),
    LOGO_NAME: "石家庄科技成果转化信息服务广场",
    WEB_HOST: "http://ww2.techchina.org.cn/#",
    menusOptions: [
        { label: "首页", path: "/", visible: true },
        { label: "话题", path: "/talk", visible: true },
        { label: "成果", path: "/result", visible: true },
        { label: "需求", path: "/demand", visible: true },
        { label: "社区", path: "/community", visible: true },
        { label: "展厅", path: "/showroom", visible: true },
    ]
}